module.exports = __webpack_public_path__ + "img/4.7183c276.jpg";